<mat-tab-group>
    <mat-tab label="Übersicht">
        <kiene-kiene-table [tableDescriptor]="tableDescriptor"></kiene-kiene-table>
    </mat-tab>
    <mat-tab label="Abgelaufene Chargen">
        <kiene-abgelaufene-chargen></kiene-abgelaufene-chargen>
    </mat-tab>
</mat-tab-group>
